import React from 'react'
import { Router } from 'react-router-dom'
import { createBrowserHistory, Update } from 'history'

export const history = createBrowserHistory()

export default function CustomBrowserRouter({
	children,
}: React.PropsWithChildren) {
	const [state, setState] = React.useState<Update>({
		action: history.action,
		location: history.location,
	})

	React.useLayoutEffect(() => {
		history.listen(setState)
	}, [])

	return (
		<Router location={state.location} navigator={history}>
			{children}
		</Router>
	)
}
